import React from "react";
import { motion } from "framer-motion";

export default function QuestionStep({ headline, instruction, options, onSelect, testidPrefix }) {
  return (
    <div className="px-6 pt-8 pb-28">
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <h1 className="font-serif-display text-4xl leading-tight text-[#1A1A1A]">
          {headline}
        </h1>
        {instruction && (
          <p className="mt-3 text-[15px] text-[#474747] leading-relaxed">{instruction}</p>
        )}
      </motion.div>

      <div className="mt-8 space-y-3">
        {options.map((o, i) => (
          <motion.button
            key={o.id}
            data-testid={`${testidPrefix}-${o.id}`}
            onClick={() => onSelect(o)}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.25, delay: 0.03 * i }}
            className="w-full text-left ss-card ss-tap ss-focus p-5 min-h-[56px]"
          >
            <div className="text-[17px] font-medium text-[#1A1A1A]">{o.title}</div>
            {o.support && (
              <div className="mt-1.5 text-[14px] text-[#6B6B6B] leading-relaxed">{o.support}</div>
            )}
          </motion.button>
        ))}
      </div>
    </div>
  );
}
